
export function create_title(title) {

  return{
    //文字内容
    text:{
      isHidden:true,//是否隐藏
      value:title//标题内容
    },

    //字体设置
    font: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor_globalColor:'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fontSize: 16,
        fsWeight: 'normal',
        fontColor_globalColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign:'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },

    //标题高度
    height:{
      radio_val:'default',
      default:{
        height:50,
      },
      custom:{
        height:50,
      }
    },

    //背景
    background:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      },
      custom:{
        type:'color', // 背景设置-类型
        img:'', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色
        img_scale: 'scale_tiling', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'auto',
        background_repeat: 'repeat',
        background_position: 'center center' //图片位置
      }
    },
  }

}



// WEBPACK FOOTER //
// ./src/base/titleData.js